import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import Translator from '../core/i18n';
import { IActivityNotificationRequest, INotificationRequest, IReadNotificationIdRequest } from '../models/pages/notifications';

const _logger = Log.create('Notification-Service');
const T = Translator.create();
let _apiClient: ApiClient;

export class NotificationService {

    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestNotificationsAsync(request: INotificationRequest) {
        const requestUrl = 'api/notifications';


        const queryString = 'notificationPanelType='+request.notificationPanelType+'&take=' + request.take + '&page=' + request.page + '&onlyUnread=' + request.onlyUnread;

        return _apiClient.RequestAsync('GET', requestUrl+ '?' +queryString).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestActivityNotificationsAsync(request: IActivityNotificationRequest) {
        const requestUrl = 'api/notifications';


        const queryString = 'notificationPanelType='+request.notificationPanelType+'&take=' + request.take + '&page=' + request.page + '&onlyUnread=' + request.onlyUnread;

        return _apiClient.RequestAsync('GET', requestUrl+ '?' +queryString).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestReadNotificationsAsync() {
        const requestUrl = 'api/notifications/readall';
        
        return _apiClient.RequestAsync('GET', requestUrl).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }



    public async RequestReadActivityNotificationsAsync() {
        const requestUrl = 'api/notifications/readall?notificationPanelType=1';
        
        return _apiClient.RequestAsync('GET', requestUrl).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }



    public async RequestReadNotificationIdAsync(request: IReadNotificationIdRequest) {
        const requestUrl = 'api/notifications/readsingle';
        const queryString = 'notificationId='+request.notificationId;

        return _apiClient.RequestAsync('GET', requestUrl+ '?' +queryString).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }
}

